import {
  toReactNodes
} from "./chunk-3NZOR3KT.js";
import {
  StyledBody,
  getPropDefaults
} from "./chunk-RKWGY5RW.js";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/components/typography/Body.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Body(props) {
  const propsWithDefaults = getPropDefaults(props);
  let reactNodes = props.children || null;
  if (props.content) {
    reactNodes = toReactNodes(props.content);
  }
  return /* @__PURE__ */ jsx(StyledBody, __spreadProps(__spreadValues({}, propsWithDefaults), { children: reactNodes }));
}

export {
  Body
};
